import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialogRef } from "@angular/material/dialog";
import { take } from "rxjs/operators";
import { CredentialsADService } from "./../../../services/credentialsAD.service";
import { Validators } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-credentials-ad",
  templateUrl: "./credentials-ad.component.html",
  styleUrls: ["./credentials-ad.component.scss"],
})
export class CredentialsAdComponent implements OnInit {
  form = this.fb.group({
    usuario: ["", Validators.required],
    clave: ["", Validators.required],
    url: ["", Validators.required],
    baseDN: ["", Validators.required],
  });

  constructor(
    public fb: FormBuilder,
    public adService: CredentialsADService,
    public matDialogRef: MatDialogRef<CredentialsAdComponent>,
    public snack: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.adService
      .get()
      .pipe(take(1))
      .subscribe((r: any) =>
        r.payload !== null
          ? this.updateValues(
              r.payload.usuario,
              r.payload.clave,
              r.payload.url,
              r.payload.baseDN
            )
          : null
      );
  }

  updateValues(usuario: string, clave: string, url: string, baseDN: string) {
    this.form.controls.usuario.setValue(usuario);
    this.form.controls.clave.setValue(clave);
    this.form.controls.url.setValue(url);
    this.form.controls.baseDN.setValue(baseDN);
  }

  save(): void {
    this.adService
      .post(this.form.value)
      .pipe(take(1))
      .subscribe((r: any) => {
        this.createSnack("Credenciales Actualizadas con Éxito");
        this.matDialogRef.close();
      });
  }

  createSnack(txt: string) {
    this.snack.open(txt, "x", { duration: 1000 });
  }
}
